"use client"

import { motion } from "framer-motion"

const technologies = [
  "HTML", "CSS", "JavaScript", "TypeScript", "React", "Next.js", "Vue.js", "Nuxt.js", 
  "Angular", "Svelte", "Astro", "Tailwind CSS", "Bootstrap", "Sass", "Node.js", 
  "Express.js", "NestJS", "Fastify", "Django", "Flask", "FastAPI", "Laravel", 
  "Spring Boot", ".NET Core", "PHP", "Java", "Python", "Go", "Rust", "C#", 
  "PostgreSQL", "MySQL", "MongoDB", "Redis", "Firebase", "Supabase", "Prisma", 
  "Drizzle ORM", "GraphQL", "Apollo", "REST API", "WebSockets", "Docker", 
  "Kubernetes", "Nginx", "Git", "GitHub", "GitLab", "CI/CD", "AWS", 
  "Google Cloud", "Azure", "Vercel", "Netlify", "Cloudflare", "Android", 
  "iOS", "Kotlin", "Swift", "Flutter", "React Native", "Dart", "Jetpack Compose", 
  "SwiftUI", "TensorFlow", "PyTorch", "Scikit-learn", "OpenAI API", "HuggingFace", 
  "LangChain", "Vector Databases", "Pinecone", "Weaviate", "Milvus", "Elasticsearch", 
  "OpenSearch", "n8n", "Zapier", "Make.com", "Webhooks", "RabbitMQ", "Kafka", 
  "OAuth", "JWT", "Web Security", "Penetration Testing", "Jest", "Cypress", 
  "Playwright", "Storybook"
]

type StatsProps = {
  locale?: string
}

export function Stats({ locale }: StatsProps) {
  // Optimize DOM size: Render twice for seamless infinite scroll
  // This reduces DOM elements from 180 to 90, but we need 2 sets for seamless loop
  // Using CSS animation with 50% width for each set
  return (
    <section className="relative py-4 sm:py-6 bg-white border-t border-slate-200 overflow-hidden w-full">
      <div className="w-full overflow-hidden" suppressHydrationWarning>
        <div className="flex gap-6 sm:gap-8 lg:gap-10 animate-scroll" style={{ width: '200%' }} suppressHydrationWarning>
          {/* First set */}
          {technologies.map((tech) => (
            <span
              key={`${tech}-1`}
              className="text-xs sm:text-sm text-slate-500 whitespace-nowrap font-medium flex-shrink-0"
              suppressHydrationWarning
            >
              {tech}
            </span>
          ))}
          {/* Second set for seamless loop */}
          {technologies.map((tech) => (
            <span
              key={`${tech}-2`}
              className="text-xs sm:text-sm text-slate-500 whitespace-nowrap font-medium flex-shrink-0"
              suppressHydrationWarning
            >
              {tech}
            </span>
          ))}
        </div>
      </div>
    </section>
  )
}
